import { create } from "zustand";
import { devtools } from "zustand/middleware";
/** Global store for the currently selected patient record. */
export var useSelectedPatientStore = create()(devtools(function (set) {
  return {
    selectedPatient: null,
    setSelectedPatient: function setSelectedPatient(patient) {
      return set({
        selectedPatient: patient
      }, false, "setSelectedPatient");
    }
  };
}, {
  name: "SelectedPatientStore",
  enabled: typeof window !== "undefined" && process.env.NODE_ENV !== "production"
}));